var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconApple2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1011_63881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1258 20.1847H33.7512V22.5626H36.1258V20.1847Z",
    fill: "#5D1C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1258 17.811H33.7512V20.1856H36.1258V17.811Z",
    fill: "#5D1C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1258 15.4365H33.7512V17.8111H36.1258V15.4365Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1258 13.0627H33.7512V15.4373H36.1258V13.0627Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1258 10.6882H33.7512V13.0628H36.1258V10.6882Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1258 8.3103H33.7512V10.6882H36.1258V8.3103Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.752 22.5626H31.3774V24.9372H33.752V22.5626Z",
    fill: "#5D1C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.752 20.1847H31.3774V22.5626H33.752V20.1847Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.752 17.811H31.3774V20.1856H33.752V17.811Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.752 15.4365H31.3774V17.8111H33.752V15.4365Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.752 13.0627H31.3774V15.4373H33.752V13.0627Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.752 10.6882H31.3774V13.0628H33.752V10.6882Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.752 8.3103H31.3774V10.6882H33.752V8.3103Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.752 5.93579H31.3774V8.31034H33.752V5.93579Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3767 24.9373H28.9988V27.3118H31.3767V24.9373Z",
    fill: "#5D1C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3767 22.5626H28.9988V24.9372H31.3767V22.5626Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3767 20.1847H28.9988V22.5626H31.3767V20.1847Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3767 17.811H28.9988V20.1856H31.3767V17.811Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3767 15.4365H28.9988V17.8111H31.3767V15.4365Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3767 13.0627H28.9988V15.4373H31.3767V13.0627Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3767 10.6882H28.9988V13.0628H31.3767V10.6882Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3767 8.3103H28.9988V10.6882H31.3767V8.3103Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3767 5.93579H28.9988V8.31034H31.3767V5.93579Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3767 3.56201H28.9988V5.93656H31.3767V3.56201Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9995 24.9373H26.625V27.3118H28.9995V24.9373Z",
    fill: "#5D1C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9995 22.5626H26.625V24.9372H28.9995V22.5626Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9995 20.1847H26.625V22.5626H28.9995V20.1847Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9995 17.811H26.625V20.1856H28.9995V17.811Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9995 15.4365H26.625V17.8111H28.9995V15.4365Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9995 13.0627H26.625V15.4373H28.9995V13.0627Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9995 10.6882H26.625V13.0628H28.9995V10.6882Z",
    fill: "#E59788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9995 8.3103H26.625V10.6882H28.9995V8.3103Z",
    fill: "#E59788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9995 5.93579H26.625V8.31034H28.9995V5.93579Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9995 3.56201H26.625V5.93656H28.9995V3.56201Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6245 24.9373H24.25V27.3118H26.6245V24.9373Z",
    fill: "#5D1C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6245 22.5626H24.25V24.9372H26.6245V22.5626Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6245 20.1847H24.25V22.5626H26.6245V20.1847Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6245 17.811H24.25V20.1856H26.6245V17.811Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6245 15.4365H24.25V17.8111H26.6245V15.4365Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6245 13.0627H24.25V15.4373H26.6245V13.0627Z",
    fill: "#E59788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6245 10.6882H24.25V13.0628H26.6245V10.6882Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6245 8.3103H24.25V10.6882H26.6245V8.3103Z",
    fill: "#E59788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6245 5.93579H24.25V8.31034H26.6245V5.93579Z",
    fill: "#E59788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6245 3.56201H24.25V5.93656H26.6245V3.56201Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2508 27.3118H21.8762V29.6863H24.2508V27.3118Z",
    fill: "#5D1C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2508 24.9373H21.8762V27.3118H24.2508V24.9373Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2508 22.5626H21.8762V24.9372H24.2508V22.5626Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2508 20.1847H21.8762V22.5626H24.2508V20.1847Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2508 17.811H21.8762V20.1856H24.2508V17.811Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2508 15.4365H21.8762V17.8111H24.2508V15.4365Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2508 13.0627H21.8762V15.4373H24.2508V13.0627Z",
    fill: "#E59788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2508 10.6882H21.8762V13.0628H24.2508V10.6882Z",
    fill: "#E59788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2508 8.3103H21.8762V10.6882H24.2508V8.3103Z",
    fill: "#E59788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2508 5.93579H21.8762V8.31034H24.2508V5.93579Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2508 3.56201H21.8762V5.93656H24.2508V3.56201Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8767 27.3118H19.4988V29.6863H21.8767V27.3118Z",
    fill: "#5D1C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8767 24.9373H19.4988V27.3118H21.8767V24.9373Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8767 22.5626H19.4988V24.9372H21.8767V22.5626Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8767 20.1847H19.4988V22.5626H21.8767V20.1847Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8767 17.811H19.4988V20.1856H21.8767V17.811Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8767 15.4365H19.4988V17.8111H21.8767V15.4365Z",
    fill: "#E59788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8767 13.0627H19.4988V15.4373H21.8767V13.0627Z",
    fill: "#E59788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8767 10.6882H19.4988V13.0628H21.8767V10.6882Z",
    fill: "#E59788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8767 8.3103H19.4988V10.6882H21.8767V8.3103Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8767 5.93579H19.4988V8.31034H21.8767V5.93579Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8767 3.56201H19.4988V5.93656H21.8767V3.56201Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4983 27.3118H17.1238V29.6863H19.4983V27.3118Z",
    fill: "#5D1C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4983 24.9373H17.1238V27.3118H19.4983V24.9373Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4983 22.5626H17.1238V24.9372H19.4983V22.5626Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4983 20.1847H17.1238V22.5626H19.4983V20.1847Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4983 17.811H17.1238V20.1856H19.4983V17.811Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4983 15.4365H17.1238V17.8111H19.4983V15.4365Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4983 13.0627H17.1238V15.4373H19.4983V13.0627Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4983 10.6882H17.1238V13.0628H19.4983V10.6882Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4983 8.3103H17.1238V10.6882H19.4983V8.3103Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4983 5.93579H17.1238V8.31034H19.4983V5.93579Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1245 27.3118H14.75V29.6863H17.1245V27.3118Z",
    fill: "#E2D7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1245 24.9373H14.75V27.3118H17.1245V24.9373Z",
    fill: "#5D1C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1245 22.5626H14.75V24.9372H17.1245V22.5626Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1245 20.1847H14.75V22.5626H17.1245V20.1847Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1245 17.811H14.75V20.1856H17.1245V17.811Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1245 15.4365H14.75V17.8111H17.1245V15.4365Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1245 13.0627H14.75V15.4373H17.1245V13.0627Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1245 10.6882H14.75V13.0628H17.1245V10.6882Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1245 8.3103H14.75V10.6882H17.1245V8.3103Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7508 29.6854H12.3762V32.0634H14.7508V29.6854Z",
    fill: "#E2D7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7508 27.3118H12.3762V29.6863H14.7508V27.3118Z",
    fill: "#E2D7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7508 24.9373H12.3762V27.3118H14.7508V24.9373Z",
    fill: "#FFF7E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7508 22.5626H12.3762V24.9372H14.7508V22.5626Z",
    fill: "#A74828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7508 20.1847H12.3762V22.5626H14.7508V20.1847Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7508 17.811H12.3762V20.1856H14.7508V17.811Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7508 15.4365H12.3762V17.8111H14.7508V15.4365Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7508 13.0627H12.3762V15.4373H14.7508V13.0627Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7508 10.6882H12.3762V13.0628H14.7508V10.6882Z",
    fill: "#C46C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3758 32.0634H10.0012V34.4379H12.3758V32.0634Z",
    fill: "#E2D7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3758 29.6854H10.0012V32.0634H12.3758V29.6854Z",
    fill: "#E2D7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3758 27.3118H10.0012V29.6863H12.3758V27.3118Z",
    fill: "#FFF7E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 32.0634H7.62256V34.4379H10.0005V32.0634Z",
    fill: "#E2D7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 29.6854H7.62256V32.0634H10.0005V29.6854Z",
    fill: "#E2D7C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 27.3118H7.62256V29.6863H10.0005V27.3118Z",
    fill: "#FFF7E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62455 29.6854H5.25V32.0634H7.62455V29.6854Z",
    fill: "#FFF7E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62455 27.3118H5.25V29.6863H7.62455V27.3118Z",
    fill: "#FFF7E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 20.1847H36.1255V22.5626H38.5V20.1847Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 17.811H36.1255V20.1856H38.5V17.811Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 15.4365H36.1255V17.8111H38.5V15.4365Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 13.0627H36.1255V15.4373H38.5V13.0627Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 10.6882H36.1255V13.0628H38.5V10.6882Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 8.3103H36.1255V10.6882H38.5V8.3103Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1255 22.5626H33.751V24.9372H36.1255V22.5626Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1255 5.93579H33.751V8.31034H36.1255V5.93579Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7517 24.9373H31.3772V27.3118H33.7517V24.9373Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7517 3.56201H31.3772V5.93656H33.7517V3.56201Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3772 27.3118H28.9993V29.6863H31.3772V27.3118Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3772 1.1875H28.9993V3.56205H31.3772V1.1875Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9993 27.3118H26.6248V29.6863H28.9993V27.3118Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9993 1.1875H26.6248V3.56205H28.9993V1.1875Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6248 27.3118H24.2502V29.6863H26.6248V27.3118Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6248 1.1875H24.2502V3.56205H26.6248V1.1875Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.251 29.6854H21.8765V32.0634H24.251V29.6854Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.251 1.1875H21.8765V3.56205H24.251V1.1875Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8765 29.6854H19.4985V32.0634H21.8765V29.6854Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8765 1.1875H19.4985V3.56205H21.8765V1.1875Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4986 29.6854H17.124V32.0634H19.4986V29.6854Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4986 3.56201H17.124V5.93656H19.4986V3.56201Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1241 29.6854H14.7495V32.0634H17.1241V29.6854Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1241 5.93579H14.7495V8.31034H17.1241V5.93579Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7503 32.0634H12.3757V34.4379H14.7503V32.0634Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7503 8.3103H12.3757V10.6882H14.7503V8.3103Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3758 34.438H10.0012V36.8125H12.3758V34.438Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3758 24.9373H10.0012V27.3118H12.3758V24.9373Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3758 22.5626H10.0012V24.9372H12.3758V22.5626Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3758 20.1847H10.0012V22.5626H12.3758V20.1847Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3758 17.811H10.0012V20.1856H12.3758V17.811Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3758 15.4365H10.0012V17.8111H12.3758V15.4365Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3758 13.0627H10.0012V15.4373H12.3758V13.0627Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3758 10.6882H10.0012V13.0628H12.3758V10.6882Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0012 34.438H7.62329V36.8125H10.0012V34.438Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0012 24.9373H7.62329V27.3118H10.0012V24.9373Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62406 32.0634H5.24951V34.4379H7.62406V32.0634Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62406 24.9373H5.24951V27.3118H7.62406V24.9373Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24955 29.6854H2.875V32.0634H5.24955V29.6854Z",
    fill: "#351003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24955 27.3118H2.875V29.6863H5.24955V27.3118Z",
    fill: "#351003"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1011_63881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple2);
export default __webpack_public_path__ + "static/media/IconApple2.588fa7a27bfc5fa74d014663dfd3aa4c.svg";
export { ForwardRef as ReactComponent };